/**
 * Selects the video element from the DOM using its class name 'js-sun-chart-video'.
 */
const video = document.querySelector('.js-sun-chart-video');

/**
 * Selects the progress bar element associated with the video, using its class name 'js-sun-chart-video-progress-bar'.
 */
const progressBar = document.querySelector('.js-sun-chart-video-progress-bar');

/**
 * Selects all elements that represent speed buttons, using their common class name 'js-speedButton'.
 */
const speedButtons = document.querySelectorAll('.js-speedButton');

/**
 * Selects the play icon element using its class name 'js-playIcon'.
 */
const playIcon = document.querySelector('.js-playIcon');

/**
 * Selects the pause icon element using its class name 'js-pauseIcon'.
 */
const pauseIcon = document.querySelector('.js-pauseIcon');

/**
 * Toggles the play/pause state of the video.
 */
function togglePlayPause() {
  if (video.paused) {
    video.play();
  } else {
    video.pause();
  }
}

/**
 * Sets the current playback time of the video to a specified value.
 * @param {number} time The new playback time in seconds.
 */
function setTime(time) {
  video.pause();
  video.currentTime = time;
}

/**
 * Changes the playback speed of the video and highlights the corresponding speed button.
 * @param {number} speed The new playback speed.
 * @param {HTMLElement} button The button element that corresponds to the new playback speed.
 */
function setPlaybackSpeed(speed, button) {
  video.playbackRate = speed;
  speedButtons.forEach(function (btn) {
    btn.classList.remove('is-active');
  });
  button.classList.add('is-active');
}

/**
 * Updates the progress bar value based on the user's input.
 */
progressBar.addEventListener('input', () => {
  const seekTime = (video.duration / 100) * progressBar.value;
  video.currentTime = seekTime;
});

/**
 * Updates the progress bar value as the video plays.
 */
video.addEventListener('timeupdate', () => {
  const time = video.currentTime;
  progressBar.value = (time / video.duration) * 100;
});

/**
 * Hides the play icon and shows the pause icon when the video starts playing.
 */
video.addEventListener('play', () => {
  playIcon.classList.remove('is-active');
  pauseIcon.classList.add('is-active');
});

/**
 * Shows the play icon and hides the pause icon when the video is paused.
 */
video.addEventListener('pause', () => {
  playIcon.classList.add('is-active');
  pauseIcon.classList.remove('is-active');
});
